import { Component } from "react";
import axios from "../../../../axios";
import classes from "./ShopItem.css";

class ShopItem extends Component {
  state = {
    order: this.props.order,
    statuses: [],
    saving: false,
  };

  loadStatuses = () => {
    axios
      .get("/shop-orders/statuses")
      .then((response) => {
        if (response.data) {
          this.setState({ statuses: response.data });
        }
      })
      .catch((err) => {
        console.error("Failed to load statuses:", err);
      });
  };

  handleStatusChange = (newStatus) => {
    this.setState({ saving: true });
    axios
      .put(`/shop-orders/${this.state.order._id}/status`, { status: newStatus })
      .then((response) => {
        this.setState({
          order: { ...this.state.order, status: newStatus },
          saving: false,
        });
        if (this.props.dataChanged) this.props.dataChanged();
      })
      .catch((err) => {
        console.error("Failed to update status:", err);
        this.setState({ saving: false });
      });
  };

  componentDidMount() {
    this.loadStatuses();
  }

  formatDate(dateStr) {
    if (!dateStr) return "N/A";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  render() {
    const { order, statuses, saving } = this.state;
    const { onClose } = this.props;
    const billing = order.billingAddress || {};
    const shipping = order.shippingAddress || {};

    return (
      <div className={classes.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
        <div className={classes.modal}>
          <div className={classes.header}>
            <div className={classes.headerLeft}>
                <h2 className={classes.title}>{order.paymentReference || "Order"}</h2>
                {
                  order.firstOrder && <span className={classes.firstOrder}>New Organization</span>
                }
            </div>
            <button className={classes.closeBtn} onClick={onClose}>✕</button>
          </div>

          <div className={classes.section}>
            <h3 className={classes.sectionTitle}>General</h3>
            <div className={classes.row}>
              <span className={classes.label}>Status</span>
              <select
                className={classes.statusSelect}
                value={order.status}
                onChange={(e) => this.handleStatusChange(e.target.value)}
                disabled={saving}
              >
                {statuses.length > 0
                  ? statuses.map((s) => {
                      const val = typeof s === "string" ? s : s.value || s.id || String(s);
                      const label = typeof s === "string"
                        ? s.charAt(0).toUpperCase() + s.slice(1)
                        : s.label || val.charAt(0).toUpperCase() + val.slice(1);
                      return (
                        <option key={val} value={val}>{label}</option>
                      );
                    })
                  : <option value={order.status}>{order.status}</option>
                }
              </select>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Date</span>
              <span className={classes.value}>{this.formatDate(order.createdAt)}</span>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Customer</span>
              <span className={classes.value}>{order.userEmail || "N/A"}</span>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Organization</span>
              <span className={classes.value}>{order.organizationName || "N/A"}</span>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>VAT Number</span>
              <span className={classes.value}>{order.vatNumber || "N/A"}</span>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>First Order</span>
              <span className={classes.value}>{order.firstOrder ? "Yes" : "No"}</span>
            </div>
          </div>

          <div className={classes.section}>
            <h3 className={classes.sectionTitle}>Items</h3>
            <div className={classes.itemsList}>
              {(order.items || []).map((item, idx) => {
                const qty = item.quantity || 1;
                const unitPrice = item.pricePerUnit || 0;
                const lineTotal = item.totalPrice || unitPrice * qty;
                const initial = (item.productName || item.productId || "?").charAt(0).toUpperCase();
                return (
                  <div key={idx} className={classes.itemCard}>
                    <div className={classes.itemAvatar}>{initial}</div>
                    <div className={classes.itemInfo}>
                      <div className={classes.itemName}>{item.productName || item.productId}</div>
                      <div className={classes.itemMeta}>
                        €{unitPrice} × {qty}
                      </div>
                    </div>
                    <div className={classes.itemTotal}>€{lineTotal}</div>
                  </div>
                );
              })}
            </div>
            <div className={classes.totalRow}>
              <span className={classes.totalLabel}>Order total</span>
              <span className={classes.totalValue}>€{order.totalAmount || 0}</span>
            </div>
          </div>

          <div className={classes.addressColumns}>
            <div className={classes.section}>
              <h3 className={classes.sectionTitle}>Billing Address</h3>
              <div className={classes.addressLine}>{billing.line1 || "—"}</div>
              {billing.line2 && <div className={classes.addressLine}>{billing.line2}</div>}
              <div className={classes.addressLine}>
                {billing.postalCode || ""} {billing.town || ""}
              </div>
              <div className={classes.addressLine}>{billing.country || ""}</div>
            </div>
            <div className={classes.section}>
              <h3 className={classes.sectionTitle}>Shipping Address</h3>
              <div className={classes.addressLine}>{shipping.line1 || "—"}</div>
              {shipping.line2 && <div className={classes.addressLine}>{shipping.line2}</div>}
              <div className={classes.addressLine}>
                {shipping.postalCode || ""} {shipping.town || ""}
              </div>
              <div className={classes.addressLine}>{shipping.country || ""}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShopItem;
